module.exports = __webpack_public_path__ + "img/dingzhiyansemofakoudaiWu.min.cc095b3c.png";